export default __webpack_public_path__ + "static/media/(38).694fcc41.jpg";